<div class="col-sm-11 center-block">
    <div class="row">
        <div class="col-sm-12">
            <h1 role="heading" tabindex="0" aria-label="Unauthorized" aria-level="1">Unauthorized</h1>
            <h2 class="text-danger" tabindex="0" aria-label="You have no rights to access the application" role="heading" aria-level="2"
            >You have no rights to access the application. Click <a [routerLink]='["/order-tracker"]' href="#" tabindex="0" role="link"
            aria-label="Click here to route to sign in page">here</a> to route to signin page.</h2>
        </div>
    </div>
</div>
